<template>
    <div>
       <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Titel der Reise</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="JourneyBuchung.journeyname" placeholder="" name="Reisetitel" :disabled="true">></el-input></el-col>
        </el-row>
        <el-row :gutter="10" style="padding:0px;">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Reisetermin</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                <el-select v-model="form.Reisetermin" placeholder="Bitte Termin wählen" name="Reisetermin" v-validate="'required'" style="width:100%;" :readonly="true">
                    <el-option v-for="termin in termine"
                        :key="termin.id_pln_dates"
                        :label="getJourneyDate(termin.dates)"
                        :value="getJourneyDate(termin.dates)">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Name</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.Name" placeholder="" name="Name" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Straße</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.Straße" placeholder="" name="Straße" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>PLZ/Ort</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.PLZ" placeholder="" name="PLZ" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Telefon</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.Telefon" placeholder="" name="Telefon" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>E-Mail-Adresse</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.EMail" placeholder="" name="E-Mail" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Anzahl Erwachsene</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.AnzahlErw" placeholder="" name="Anzahl Erwachsene" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Anzahl Kinder</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input v-model="form.AnzahlKin" placeholder="" name="Anzahl Kinder" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"><div>Nachricht eingeben</div></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"><el-input type="textarea" :rows="3" v-model="form.Nachricht" placeholder=""></el-input></el-col>
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="2"><el-checkbox v-model="checkedDatenschutz" name="Datenschutz" v-validate="'required:invalidateFalse'"></el-checkbox></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="22"
                ><span style="font-weight:bold"
                    >Ja, ich habe die <a href="#/article/Datenschutz">Datenschutzerklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng
                    zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage genutzt.</span
                ></el-col
            >
        </el-row>

        <el-row>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="2"><el-checkbox v-model="checkedAGB" name="AGB" v-validate="'required:invalidateFalse'"></el-checkbox></el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="22"
                ><span style="font-weight:bold">Ja, ich habe die <a href="#/article/AGB">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.</span></el-col
            >
        </el-row>

        <el-button type="warning" @click="sendForm">Anfrage senden</el-button>
    </div>
</template>

<script>

import { mapState } from "vuex";

export default {
    props: {
        reisename: {
            type: String,
            default: ""
        },
        termine: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            form: {
                Formular: "Reiseanfrage",
                Reisettitel: "",
                Reisetermin: "",
                Name: "",
                Straße: "",
                PLZ: "",
                Telefon: "",
                EMail: "",
                AnzahlErw: "",
                AnzahlKin: "",
                Nachricht: "",
            },
            checkedAGB: false,
            checkedDatenschutz: false,
            checkedPauschal: false
        }
    },
    computed: {
         ...mapState(["JourneyBuchung"]),      
    },
    mounted() {},
    methods: {
        sendForm() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$alert(this.errors.all().join("<br>"), "Fehler", { dangerouslyUseHTMLString: true })
                    return
                }

                let formData = new FormData()
                formData.append('Reisename', this.reisename)
                for (const key in this.form) {
                    formData.append(key, this.form[key])
                }

                fetch("php/mail_action.php", { method: "POST", body: formData })
                    .then(res => res.text())
                    .then(jsonData => {
                        this.form = {}
                        this.$emit("getHiddenBooking");                       
                        this.$alert("Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.", "Mail versendet", { dangerouslyUseHTMLString: true })
                    })
                    .catch(error => {
                        this.$alert("Die E-Mail konnte leider nicht versendet werden.", "Fehler", { dangerouslyUseHTMLString: true })
                        return
                    })
            })
        },
        getJourneyDate(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from))
            }
            return new Intl.DateTimeFormat("de-DE", { month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from)) + " - " + new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_till))
        },
    }
}
</script>

<style lang="scss">
.el-row {
    padding: 10px 0px;
}
.us-form-label {
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
}
.el-button {
    width: 100%;
    background-color: #ee9301;
}


.el-input__inner {
    background-color: #fff !important;
}
</style>